/**
 * Quando una risposta parlata non e' utilizzabile cosi' com'e'.
 *
 * Fino a oggi l'unico controllo era l'uguaglianza a stringa vuota, ripetuta in
 * quattro punti. Conseguenza: "Sì." passa, viene salvata, prende 0, e quello 0
 * entra nella media. Un solo zero su sei domande costa 1,17 punti su 10.
 *
 * La soglia e' BASSA di proposito: cinque parole non giudicano la qualita'
 * della risposta, distinguono una risposta da un incidente del microfono.
 * Sopra la soglia non si chiede niente, come prima.
 */

export const MIN_PAROLE = 5;

/** Parole vere, senza contare la punteggiatura sciolta. */
export const contaParole = (testo) =>
  (testo || "")
    .trim()
    .split(/\s+/)
    .filter((parola) => /[\p{L}\p{N}]/u.test(parola)).length;

/**
 * "vuota" e' ESATTAMENTE quello che era vuoto anche prima della soglia:
 * stringa vuota dopo il trim. Non "zero parole".
 *
 * La differenza si vede su una trascrizione di sola punteggiatura ("...", "?"),
 * che i motori STT restituiscono sul rumore: ha zero parole ma non e' vuota.
 * Contandola come vuota avrebbe aperto il popup storico anche a flag SPENTO,
 * cioe' un cambio di comportamento fuori dal flag. Cosi' invece e' "breve", e
 * col flag spento passa come e' sempre passata.
 *
 * @returns {'ok'|'vuota'|'breve'}
 */
export const esitoRisposta = (testo) => {
  if (!testo || testo.trim() === "") return "vuota";
  return contaParole(testo) < MIN_PAROLE ? "breve" : "ok";
};

export default esitoRisposta;
